var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"scrollButton",class:[{inactive: !_vm.scrollButtonVisible}, 'scroll-top'],on:{"click":_vm.scrollTop}},[_vm._v("Наверх")])}
var staticRenderFns = []

export { render, staticRenderFns }